var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-box",
    {
      attrs: {
        "is-visible": true,
        "body-class-list": ["gfu-zoomable-gallery-modal"],
        "data-qa": "zoomable-gallery-modal",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "gfu-zoomable-gallery-modal__nav _flexbtwn _ai-c _px-3 _py-3",
        },
        [
          _c("span", { staticClass: "_tc--gray" }, [
            _vm._v(_vm._s(_vm.galleryNavigationText)),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "_flexaicntr _tc--accent _ml-a",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onGalleryClose.apply(null, arguments)
                },
              },
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.Resources.Common.ModalCloseButton)),
              ]),
              _vm._v(" "),
              _c("base-icon", {
                staticClass: "modal-navigation__icon _ml-1 _fr",
                attrs: { name: "times", "data-qa": "modal-button:Close" },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gfu-zoomable-gallery" },
        [
          _c("progress-overlay", { attrs: { visible: !_vm.isMediaLoaded } }),
          _vm._v(" "),
          _c("base-carousel", {
            staticClass: "gfu-zoomable-gallery__slider",
            attrs: {
              current: _vm.currentDisplayedMedia,
              "can-swipe": _vm.canSwipe,
            },
            on: { change: _vm.onChange },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return _vm._l(_vm.mappedMedia, function (medium, index) {
                    return _c(
                      "div",
                      {
                        key: medium.mediaUrl + index,
                        class: medium.slideClasses,
                      },
                      [
                        _vm.isTypeVideo
                          ? _c("div", [
                              medium.isActive
                                ? _c(
                                    "video",
                                    {
                                      staticClass:
                                        "gfu-zoomable-gallery__video",
                                      attrs: {
                                        controls: "",
                                        autoplay: "",
                                        preload: "metadata",
                                        src: medium.mediaUrl,
                                        "data-qa": `zoomable-gallery-video${
                                          medium.isActive ? "-active" : ""
                                        }`,
                                      },
                                      on: { loadedmetadata: _vm.onMediaLoaded },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Your browser does not support the video tag.\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _c(
                              "div",
                              {
                                ref: "imageContainer",
                                refInFor: true,
                                staticClass:
                                  "gfu-zoomable-gallery__image _flexcntr _ai-c",
                              },
                              [
                                _c("base-image", {
                                  ref: "image",
                                  refInFor: true,
                                  class: _vm.imageClass,
                                  attrs: {
                                    draggable: "false",
                                    src: medium.mediaUrl,
                                    "data-qa": `zoomable-gallery-image${
                                      medium.isActive ? "-active" : ""
                                    }`,
                                  },
                                  on: { load: _vm.onMediaLoaded },
                                }),
                              ],
                              1
                            ),
                      ]
                    )
                  })
                },
                proxy: true,
              },
              {
                key: "controls",
                fn: function ({ onNext, onPrev }) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "gfu-zoomable-gallery__controls _flexbtwn _ai-c _px-4",
                      },
                      [
                        _vm.hasMoreThanOneSlide
                          ? _c("base-carousel-navigation", {
                              staticClass: "gfu-zoomable-gallery-nav-item",
                              attrs: {
                                type: "prev",
                                icon: "angle-left",
                                "data-qa": "previous-button",
                              },
                              on: { click: onPrev },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isTypeVideo
                          ? _c(
                              "div",
                              { staticClass: "_flex _jc-c _gap-1 _grow-1" },
                              [
                                _c("base-carousel-navigation", {
                                  ref: "zoomOutButton",
                                  staticClass: "gfu-zoomable-gallery-nav-item",
                                  attrs: {
                                    icon: "minus",
                                    "data-qa": "zoom-out-button",
                                  },
                                }),
                                _vm._v(" "),
                                _c("base-carousel-navigation", {
                                  ref: "zoomInButton",
                                  staticClass: "gfu-zoomable-gallery-nav-item",
                                  attrs: {
                                    icon: "plus",
                                    "data-qa": "zoom-in-button",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasMoreThanOneSlide
                          ? _c("base-carousel-navigation", {
                              staticClass: "gfu-zoomable-gallery-nav-item",
                              attrs: {
                                type: "prev",
                                icon: "angle-right",
                                "data-qa": "next-button",
                              },
                              on: { click: onNext },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }